import moment from 'moment';

import constants from '@/common/constants';
import Utils from '@/common/utils';

import { TStatisticsPublicFilter } from '../types/statistics/statistics-public';

export default {
  exportExcel: function (request: TStatisticsPublicFilter) {
    return Utils.downloadFile(
      'api/auditportalstatistic/exportadminexcel',
      `Website_statistics_${moment().format(constants.DATE_FORMATS['YYYYMMDD'])}.xlsx`,
      request,
      true,
    );
  },
};
